// Arena movement helpers — ported from adventure-craft
// `packages/rpg-combat/src/arena/arenaMovement.ts` (phase D of the AOD
// Studio arc). Pure tuple-based XZ math with zero adventure-craft imports
// (the port-safe rule, docs/aod-studio-design.md §1.3). Y is kept in the
// tuple shape the original uses so the port stays diffable against its
// source; AoD's board is flat, so every y stays 0.

export type Vec3 = [number, number, number];

export function distance3D(a: Vec3, b: Vec3): number {
  const dx = a[0] - b[0];
  const dy = a[1] - b[1];
  const dz = a[2] - b[2];
  return Math.sqrt(dx * dx + dy * dy + dz * dz);
}

export function normalize(from: Vec3, to: Vec3): Vec3 {
  const dx = to[0] - from[0];
  const dy = to[1] - from[1];
  const dz = to[2] - from[2];
  const len = Math.sqrt(dx * dx + dy * dy + dz * dz);
  if (len === 0) return [0, 0, 0];
  return [dx / len, dy / len, dz / len];
}

export function moveToward(from: Vec3, to: Vec3, speed: number): Vec3 {
  const dir = normalize(from, to);
  return [from[0] + dir[0] * speed, from[1] + dir[1] * speed, from[2] + dir[2] * speed];
}

export function moveAway(from: Vec3, to: Vec3, speed: number): Vec3 {
  const dir = normalize(from, to);
  return [from[0] - dir[0] * speed, from[1] - dir[1] * speed, from[2] - dir[2] * speed];
}
